// Widgets
import TeamMetricTable from 'legacy/javascripts/components/team_metric_table.es6.jsx';
import StarRating from 'legacy/javascripts/components/star_rating.es6.jsx';
import StarRatingByChannel from 'legacy/javascripts/components/star_rating_by_channel.es6.jsx';
import AreasOfImprovement from 'legacy/javascripts/components/areas_of_improvement.es6.jsx';
import AreasOfExcellence from 'legacy/javascripts/components/areas_of_excellence.es6.jsx';
import TeamDataPerMember from 'legacy/javascripts/components/team_data_per_member.es6.jsx';
import TagPerformance from 'legacy/javascripts/components/tag_performance.es6.jsx';
import RequestsSent from 'legacy/javascripts/components/requests_sent.es6.jsx';
import TeamComparison from 'legacy/javascripts/components/team_comparison.es6.jsx';
import CompanyComparison from 'legacy/javascripts/components/company_comparison.es6.jsx';
import AvgStarRating from 'legacy/javascripts/components/avg_star_rating.es6.jsx';
import ServiceRecoveryFunnel from 'legacy/javascripts/components/service_recovery_funnel.es6.jsx';
import RecoveryByTeamMember from 'legacy/javascripts/components/recovery_by_team_member.es6.jsx';
import DoNotSendCategories from 'legacy/javascripts/components/do_not_send_categories.es6.jsx';
import FollowUpCategories from 'legacy/javascripts/components/follow_up_categories.es6.jsx';
import Overview from 'legacy/javascripts/components/overview.es6.jsx';
import EmptyFilters from 'legacy/javascripts/components/empty_filters.es6.jsx';
import HeaderFilters from 'legacy/javascripts/components/header_filters.es6.jsx';
import StarDistribution from 'legacy/javascripts/components/star_distribution.es6.jsx';
import AdditionalQuestionMultipleChoice from 'legacy/javascripts/components/additional_question_multiple_choice.es6.jsx';
import AdditionalQuestionNps from 'legacy/javascripts/components/additional_question_nps.es6.jsx';
import AdditionalQuestionScalar from 'legacy/javascripts/components/additional_question_scalar.es6.jsx';
import CoachingSessionLog from 'legacy/javascripts/components/coaching_session_log.es6.jsx';
import TeamMemberTrendsLink from 'legacy/javascripts/components/team_member_trends_link.es6.jsx';

export default {
  TeamMetricTable,
  StarRating,
  StarRatingByChannel,
  AreasOfImprovement,
  AreasOfExcellence,
  TeamDataPerMember,
  TagPerformance,
  RequestsSent,
  TeamComparison,
  CompanyComparison,
  AvgStarRating,
  ServiceRecoveryFunnel,
  RecoveryByTeamMember,
  DoNotSendCategories,
  FollowUpCategories,
  Overview,
  EmptyFilters,
  HeaderFilters,
  StarDistribution,
  AdditionalQuestionMultipleChoice,
  AdditionalQuestionNps,
  AdditionalQuestionScalar,
  CoachingSessionLog,
};
